export class EventEmitter<Events extends Record<string, unknown> = Record<string, unknown>> {
  private readonly handlers: Map<keyof Events, Set<(payload: Events[keyof Events]) => void>> = new Map();

  public on<E extends keyof Events>(event: E, handler: (payload: Events[E]) => void): () => void {
    if (!this.handlers.has(event)) {
      this.handlers.set(event, new Set());
    }

    (this.handlers.get(event) as Set<(payload: Events[E]) => void>).add(handler);

    return () => this.off(event, handler);
  }

  public off<E extends keyof Events>(event: E, handler: (payload: Events[E]) => void): void {
    (this.handlers.get(event) as Set<(payload: Events[E]) => void> | undefined)?.delete(handler);
  }

  public emit<E extends keyof Events>(event: E, payload?: Events[E]): void {
    (this.handlers.get(event) as Set<(payload: Events[E]) => void> | undefined)?.forEach(cb => cb(payload as Events[E]));
  }
} 